module.exports = __webpack_public_path__ + "assets/74935af3f3e00b8fd95b8274ccb357e9-DSC_0754.jpg";